import { Injectable } from '@angular/core';

@Injectable()
export class Cnae {

    allCnaes = [
        {
            sapId: 'SERV0003',
            desc: "ELABORAÇÃO DE PROGRAMAS DE COMPUTADORES (SOFTWARE), INCLUSIVE DE JOGOS"
        },
        {
            sapId: 'SERV0004',
            desc: "ASSESSORIA E CONSULTORIA EM INFORMÁTICA",
        },
        {
            sapId: 'SERV0005',
            desc: "FEIRAS EXPOSIÇÕES CONGRESSOS E CONGÊNERES",
        },
        {
          sapId: 'SERV0007',
          desc: "ASSESSORIA OU CONSULTORIA DE QUALQUER NATUREZA, NÃO CONTIDA EM OUTROS",
        },
        {
            sapId: 'SERV0008',
            desc: "PROCESSAMENTO, ARMAZENAMENTO OU HOSPEDAGEM DE DADOS, TEXTOS, IMAGENS, VIDEOS, PAGINAS ELETRONICAS"
        },
        {
            sapId: 'SERV0010',
            desc: "LICENCIAMENTO OU CESSÃO DE DIREITO DE USO DE PROGRAMAS DE COMPUTAÇÃO,",
        },
        {
            sapId:'SERV0011',
            desc:'FORNECIMENTO DE MAO DE OBRA EM CARATER TEMPORARIO'
        },
        {
            sapId: 'SERV0012',
            desc: "DESENVOLVIMENTO E LICENCIAMENTO DE PROGRAMAS DE COMPUTADOR CUSTOMIZÁVEIS – DESENVOLVIMENTO",
        },
        {
            sapId: 'SERV0013',
            desc: "ANÁLISE E DESENVOLVIMENTO DE SISTEMAS",
        },
        {
            sapId: 'SERV0014',
            desc: "PRESTAÇÃO DE SERVIÇOS INTERNACIONAIS",
        },
    ];
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/billing-letter/Cnae.ts